/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SequenceRulesNotInterestedAction = typeof SequenceRulesNotInterestedAction[keyof typeof SequenceRulesNotInterestedAction];


export const SequenceRulesNotInterestedAction = {
  do_nothing: 'do_nothing',
  archive: 'archive',
  move_stage: 'move_stage',
} as const;
